import { gql } from 'apollo-angular';

export const GET_EMAIL_VALIDATION = gql`
  query validateEmail($emailAddress: String) {
    validateEmail(emailAddress: $emailAddress) {
      id
    }
  }
`;

export type GetEmailValidationVariables = {
  emailAddress: string;
};
